module.exports = __webpack_public_path__ + "static/media/90.edfaf1d3.png";